module.exports = __webpack_public_path__ + "static/wendt-4ae23ca8aaab40214641933a502beac2.jpg";